import React, { useEffect, useState } from "react";
import styles from "./Input.module.css";

function Input(props) {
  let type = props.type || "text";
  let disabled = props.disabled || false;
  let value = props.value || "";
  let style = props.style || {};
  let onEnter = props.onEnter || null;
  let regex = props.regex || null;
  let onFocus = props.onFocus || null;
  let onBlur = props.onBlur || null;
  let onChange = props.onChangeEvt || null;
  let name = props.name || null;
  let id = props.id || null;
  let classNameLabel = props.classNameLabel || null;
  let icon = props.icon || null;
  let onIconClick = props.onIconClick || null;
  let importantText = props.importantText || false;
  const readonly = props.readonly || false;

  const maskPid = !!props.maskPid;

  const [warn, setWarn] = useState(props.disabled || false);
  const [showMask, setShowMask] = useState(true);

  useEffect(() => {
    setWarn(props.validate);
  }, [props.validate]);

  const maskPidValue = (val) => {
    if (!val) return "";
    if (val.length <= 2) return val;
    return "*".repeat(val.length - 2) + val.slice(-2);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && onEnter) {
      onEnter();
    }
  };

  return (
    <div>
      {props.label || (props.placeholder && !props.disabledLabel) ? (
        <label
          htmlFor={id}
          className={classNameLabel ? classNameLabel : styles.label}
        >
          {props.label}
        </label>
      ) : null}

      <div
        className="relative inline-block w-full rounded-[5px] mt-[2px] border border-[#A2B5BC] overflow-hidden"
        style={disabled ? { borderColor: "#d3d2d2" } : {}}
      >
        <input
          type={type}
          id={id}
          name={name}
          value={maskPid && showMask ? maskPidValue(value) : value}
          className={`${icon ? styles.input_icon : styles.input} ${
            warn ? styles.warn : ""
          } ${disabled ? styles.disabled : ""} ${value ? "" : styles.value}`}
          style={style}
          disabled={disabled}
          readOnly={readonly}
          placeholder={props.placeholder}
          maxLength={props.maxLength}
          onFocus={(e) => {
            setShowMask(false);
            onFocus && onFocus(e);
          }}
          onBlur={(e) => {
            if (maskPid) setShowMask(true);
            onBlur && onBlur(e);
          }}
          onChange={(e) => {
            const inputValue = e.target.value;

            if (regex) {
              if (regex.condition.test(inputValue)) {
                props.setValue
                  ? props.setValue(inputValue)
                  : onChange(e);

                setWarn(!regex.regex.test(inputValue));
              }
            } else {
              props.setValue
                ? props.setValue(inputValue)
                : onChange(e);
            }
          }}
          onKeyDown={handleKeyDown}
        />

        {icon && (
          <button
            className={styles.button_icon}
            onClick={(e) => {
              if (props.onIconClick) onIconClick(e);
            }}
          >
            {icon}
          </button>
        )}
      </div>
    </div>
  );
}

export default Input;
